<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'railway')"

  >

    <template #addDataForm>
      <railway-add-update></railway-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">
      <template v-if="cell.field.key === 'railway'">
          <template v-if="get(cell.item, 'id')">
            <railway-cell :data="cell.item"></railway-cell>
          </template>
          <template v-else>
            {{cell.item}}
          </template>
      </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../railwayStoreModule'
  import useRailway from '../useRailway'

  import RailwayAddUpdate from '../components/RailwayAddUpdate'
  import RailwayCell from "../components/RailwayCell";

  import get from 'lodash.get'


  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        RailwayCell,
      ElementsLayout,
      RailwayAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useRailway();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
